import { Box, CircularProgress, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

export const TableLoadingOverlay = ({ message }: { message: string }) => {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        backgroundColor: "white"
      }}
    >
      <CircularProgress />
      <Typography>{t(message)}</Typography>
    </Box>
  );
};
